import { ModeratorsPage } from "./ModeratorsPage";

const pages = {
  ModeratorsPage,
};
export default pages;
